import { styled } from '@mui/system';

export const PhoneNumber = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  marginTop: '4px',
});

export const Label = styled('label')({
  fontFamily: 'Roboto-Regular',
  fontStyle: 'normal',
  fontWeight: 400,
  fontSize: '30px',
  letterSpacing: '0.15px',
  color: '#2C3542',
});
